import "../utils/staleChunkReload"

require("../utils/startRailsUjs")
require("../src/application/setup")
require("../src/application/toggle-controls")

import "../stylesheets/home-search.css.sass"
import ReactOnRails from "react-on-rails"

import MobileMenu from "../components/header/MobileMenu"
import SearchPage from "../pages/SearchPage"
import TopNavSearchBox from "../pages/SearchPage/TopNavSearchBox"
// eslint-disable-next-line no-unused-vars
import dayJsPlugins from "../utils/dayJsPlugins"

const components = {
  SearchPage,
  MobileMenu,
  TopNavSearchBox
}

ReactOnRails.register(components)
